import { Helmet } from 'react-helmet-async';

function SEO(props) {
  var siteName = 'Anthroper';
  var fullTitle = props.title ? props.title + ' | ' + siteName : siteName;
  var baseUrl = 'https://anthroper.com';
  var url = baseUrl + (props.path || '');
  var image = props.image || baseUrl + '/logo-anthroper.svg';
  var twitterCard = props.image ? 'summary_large_image' : 'summary';

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={props.description} />
      <meta name="robots" content="index, follow" />
      <link rel="canonical" href={url} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={props.description} />
      <meta property="og:type" content={props.type || 'website'} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={image} />
      <meta property="og:site_name" content={siteName} />
      <meta name="twitter:card" content={twitterCard} />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={props.description} />
      <meta name="twitter:image" content={image} />
    </Helmet>
  );
}

export default SEO;
